const NAME_SPACE = "YX_30_";
const FOREVER_KEY = "FOREVER_YX_30";
export default class LocalStorage {
  static get(key) {
    const realKey = LocalStorage.getKey(key);
    const foreverKey = LocalStorage.getKey(key, true);
    const value = localStorage[realKey] || localStorage[foreverKey];
    try {
      return JSON.parse(value);
    } catch (error) {
      return undefined;
    }
  }

  static set(key, value, storeForever = false) {
    const realKey = LocalStorage.getKey(key, storeForever);
    const val = JSON.stringify(value);
    localStorage[realKey] = val;
  }

  static clear(key) {
    const realKey = LocalStorage.getKey(key);
    localStorage.removeItem(realKey);
  }

  // 清空本地缓存
  static clearAll() {
    const length = localStorage.length;
    let removeItem = [];
    for (let index = 0; index < length; index++) {
      const key = localStorage.key(index);
      if (key.startsWith(NAME_SPACE)) {
        removeItem.push(key);
      }
    }

    removeItem.forEach((item) => {
      localStorage.removeItem(item);
    });
  }

  static getKey(key, storeForever = false) {
    return storeForever ? `${FOREVER_KEY}_${key}` : `${NAME_SPACE}${key}`;
  }
}
